import BaseObjectStore from './base-object.store';

class EducationalResourceStore extends BaseObjectStore {
  constructor(props) {
    super(props);
    this.name = 'educationalResource';
  }

  resetAllFields() {
    this.resetAllBaseFields();
  }
}

export default new EducationalResourceStore();
